import type { SortingState } from '@cobliteam/ui-business/components/DataTable';
import { snakeCase } from 'change-case';

export type Sort = { key: string; desc: 'asc' | 'desc' } | undefined;

export const dataTableSortHandler = (callback: (newSort?: Sort) => void) => (sorts: SortingState) => {
  const newSort = sorts.length
    ? ({
        key: snakeCase(sorts[0].id),
        desc: sorts[0].desc ? 'desc' : 'asc',
      } as Sort)
    : undefined;

  callback(newSort);
};
